import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 7h-6l4 5l-4 5h6l4 -5l-4 -5","key":"svg-0"}]]

/**
 * IconArrowBadgeRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctYmFkZ2UtcmlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEzIDdoLTZsNCA1bC00IDVoNmw0IC01bC00IC01IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-badge-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowBadgeRight = createReactComponent('outline', 'arrow-badge-right', 'ArrowBadgeRight', __iconNode);

export default IconArrowBadgeRight;